import { withCompController } from '@wix/editor-elements-integrations';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import type {
  ClassicSectionProps,
  IClassicSectionStateValues,
} from '../ClassicSection.types';

export default withCompController<
  ClassicSectionProps,
  ClassicSectionProps,
  ClassicSectionProps,
  IClassicSectionStateValues
>(({ mapperProps, stateValues }) => {
  const { experiments = {} } = stateValues;
  const isPlayPauseSectionExperimentOn = isExperimentOpen(
    experiments,
    'specs.thunderbolt.playPauseSection',
  );

  return {
    ...mapperProps,
    isPlayPauseSectionExperimentOn,
  };
});
